import React from 'react';
import PropTypes from 'prop-types';

const Users = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={22} fill="none" viewBox="0 0 25 22" {...props}>
    <g stroke={color} strokeLinejoin="round" clipRule="evenodd">
      <path d="M1 7.932V11c0 .844.177 1.534 1.014 1.534v4.601h3.042v-4.601c.836 0 1.013-.692 1.014-1.534V7.932H1ZM19.253 7.932V11c0 .844.177 1.534 1.014 1.534v4.601h3.042v-4.601c.836 0 1.013-.692 1.014-1.534V7.932h-5.07ZM9.112 7.932h7.099v5.113a2.043 2.043 0 0 1-2.028 2.045v6.136H11.14V15.09a2.042 2.042 0 0 1-2.028-2.045V7.932ZM5.056 4.353c0 .846-.682 1.534-1.521 1.534-.84 0-1.521-.688-1.521-1.534 0-.847.681-1.534 1.52-1.534.84 0 1.522.687 1.522 1.534ZM23.31 4.353c0 .846-.682 1.534-1.521 1.534-.84 0-1.521-.688-1.521-1.534 0-.847.681-1.534 1.52-1.534.84 0 1.522.687 1.522 1.534ZM15.197 3.33a2.545 2.545 0 0 1-2.535 2.557 2.545 2.545 0 0 1-2.535-2.557A2.545 2.545 0 0 1 12.662.774c1.4 0 2.535 1.144 2.535 2.556Z" />
    </g>
  </svg>
);

Users.propTypes = {
  color: PropTypes.string
};

export default Users;
